export { default as SearchResults } from './SearchResults/SearchResults'
